var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table-component", {
    attrs: {
      parent: _vm.parent,
      content: _vm.content,
      config: _vm.tableConfig,
      timestamp: _vm.timestamp,
      selected: _vm.selected,
      createData: _vm.createData,
      updateBatch: _vm.updateBatch,
      deleteData: _vm.deleteData,
      changeUrl: _vm.changeUrl,
      changeQuery: _vm.changeQuery,
      query: _vm.query,
      onCreating: _vm.onCreating,
      onInitialized: _vm.onInitialized,
      onSelected: _vm.onSelected,
      addNotification: _vm.addNotification
    }
  })
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c58c9af4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c58c9af4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/CollectionComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c58c9af4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/CollectionComponent.vue
// module chunks = 0